const MenuList =[
    {
        id : 1,
        hyper_link : '#home',
        link_name : "Home"
    },
    {
        id : 2,
        hyper_link : '#about',
        link_name : "About"
    },
    {
        id : 1,
        hyper_link : '#projects',
        link_name : "Projects"
    },
    {
        id : 1,
        hyper_link : '#contact',
        link_name : "Contact"
    },
]

export {MenuList}